module.exports = __webpack_public_path__ + "static/img/06_active.13b19fed.jpg";